export const useStyles = () => ({
  iframeWrapper: {
    width: '100%',
    height: 'calc(100vh - 130px)',
    overflowY: 'hidden',
    '& iframe': {
      width: '100%',
      height: 'calc(100vh - 130px)',
      margin: 0,
      fontSize: 14,
      border: 'none',
    },
    '@media (max-width: 460px)': {
      height: 'calc(100dvh - 100px)',

      '& iframe': {
        height: 'calc(100dvh - 100px)',
      },
    },

    '@media (max-width: 340px)': {
      height: 'calc(100dvh - 78px)',

      '& iframe': {
        height: 'calc(100dvh - 78px)',
      },
    },
  },

  back: {
    position: 'fixed',
    top: 180,
    left: 60,
  },
});
